/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
// vendors
import { useQuery } from 'react-query';
import React, { useMemo, useState } from 'react';

// lego
import { Tabs, Icon, PhotoUploader } from 'lego-dist';

// components
import Dialog from 'components/dialog/Dialog';
import SettingsForm from './SettingsForm';
import GeneralInfoForm from './GeneralInfoForm';

// constants
import { teacherQuery } from '../queryConfig';
import { AWS_KEY, AWS_REGION, FILES_API_URL, S3_BUCKET_FILES } from 'config';

// hooks
import { useRouter } from 'routes';
import { Trans, useTranslation } from 'react-i18next';

// styles
import { Container, ContentContainer } from './styles/TeacherProfileContainer';
import { Header, Title } from './styles/TeacherProfileHeader';
import {
  TeacherName,
  TeacherRole,
  AvatarSectionContainer,
} from './styles/TeacherProfileAvatarSection';
import { Row, Col } from './styles/Commons';
import { Dropdown, DropdownItem } from './styles/TeacherProfileDelete';
import { APP_SECTIONS_PATHS } from 'constants/routes';
import Breadcrumbs from 'components/shared/Breadcrumbs';
import themes from 'themes';
import RendererIf from 'components/RendererIf';
import useCurrentUser from 'hooks/useCurrentUser';
import { ActionPermission } from 'lib/specialPermissions';
import { IETabValues } from '../center/CenterView';

const tabs = [
  {
    freemium: true,
    type: 'General',
    label: <Trans>settings:CENTER_SECTION.TABS.GENERAL</Trans>,
    View: GeneralInfoForm,
  },
  {
    freemium: true,
    disabled: false,
    View: SettingsForm,
    label: <Trans>settings:CENTER_SECTION.TABS.CONFIGURATION</Trans>,
    type: 'Configuration',
  },
];

let uploadUserAvatarToS3: any;
let userDataToUpdate: any;

function TeacherProfile() {
  const { t: translate } = useTranslation();
  const [CurrentTab, setCurrentTab] = useState(tabs[0]);
  const { can } = useCurrentUser();
  const [showDeleteTeacherModal, setShowDeleteTeacherModal] = useState(false);
  const {
    navigateTo,
    currentParamsRef: {
      current: { centerId, centerName, teacherId, prev, className, classId, groupId, externalIdValue },
    },
  } = useRouter();

  const { getTeacher, deleteTeacher, editTeacher } = teacherQuery;
  const { data, isError, refetch: fetchTeacher } = useQuery(
    getTeacher.key,
    () => getTeacher.resource({ teacherId, centerId }),
    getTeacher.config,
  );

  const { isSuccess: teacherDeleted, refetch: removeTeacher } = useQuery(
    deleteTeacher.key,
    () => deleteTeacher.resource(centerId, teacherId),
    deleteTeacher.config,
  );

  let teacherData = { ...data?.user };

  // To update teacher avatar
  const { refetch: setTeacher } = useQuery(
    editTeacher.key,
    () => editTeacher.resource(userDataToUpdate, centerId, teacherData.id),
    editTeacher.config,
  );

  useMemo(() => {
    if (!isError && centerId && teacherData?.id != teacherId) {
      teacherData = {};
      fetchTeacher();
    }
  }, [centerId, teacherId, teacherData]);

  const onClickTab = ({ currentSelected }: any) => {
    if (currentSelected) {
      setCurrentTab(currentSelected);
    }
  };

  useMemo(() => {
    if (teacherDeleted) {
      if( origin === 'staff' ) {
        navigateTo(APP_SECTIONS_PATHS.SETTINGS, {
          section: 'staff',
        });
      } else if( origin === 'classroom') {
        navigateTo(APP_SECTIONS_PATHS.CLASSROOM_DETAILS, {
          centerId,
          centerName,
          className,
          groupId,
          externalIdValue,
          tab: IETabValues.TEACHERS
        });
      } else {
        navigateTo(APP_SECTIONS_PATHS.CENTER_SETTINGS, {
          centerId,
          centerName,
          tab: IETabValues.TEACHERS
        });
      }
    }


  }, [teacherDeleted]);

  const onDeleteTeacher = () => {
    removeTeacher();
  };

  const onUploadedTeacherAvatar = (s3filePath: string, croppedFile: any) => {
    const s3FilesAttributes = [
      {
        file_name: s3filePath,
        status: 'Complete',
        mime_type: croppedFile.type,
        service_urls_attributes: [
          {
            record_type: 'thumbnail_url',
            url: s3filePath,
          },
        ],
      },
    ];
    userDataToUpdate = {
      user: {
        s3_files_attributes: s3FilesAttributes,
      },
    };
    setTeacher();
  };

  const handleOnUpdateInformation = () => fetchTeacher();

  const renderDeleteTeacherModal = () => (
    <Dialog
      mainText={translate('common:DELETE')}
      cancelText={translate('common:CANCEL')}
      title={translate('settings:DELETE_TEACHER')}
      show={showDeleteTeacherModal}
      onMainAction={onDeleteTeacher}
      onDialogClose={() => setShowDeleteTeacherModal(false)}
      onCancelAction={() => setShowDeleteTeacherModal(false)}
    >
      <>{translate('settings:CENTER_SECTION.DELETE_THIS_TEACHER')}</>
    </Dialog>
  );

  const handlePrevUrl = (type: string) => {
    let url;
    let name;

    if (prev !== undefined) {
      name = prev === 'center' ? centerName : className;
      url =
        prev === 'center'
          ? `center-view?centerId=${centerId}`
          : `classroom-view?classId=${classId}`;
    }

    if (name === undefined || name === 'undefined') {
      name = 'center';
      url = APP_SECTIONS_PATHS.SETTINGS;
    }

    return type === 'name' ? name : url;
  };

  const links = [
    { name: translate('settings:SETTINGS'), url: APP_SECTIONS_PATHS.SETTINGS },
    { name: handlePrevUrl('name'), goBack: true },
  ];

  const renderTeacherInfo = () => {
    if (Object.keys(teacherData).length > 0) {
      return (
        <>
          <AvatarSectionContainer disable={!can(ActionPermission.EDIT_TEACHERS)}>
            <PhotoUploader
              multipart
              withDefaultIcon={false}
              previewModalProps={{ headerColor: themes.colors.newKinedu }}
              src={teacherData?.avatar}
              defaultLetter={teacherData?.name?.charAt(0).toUpperCase()}
              onCroppedFile={({ uploadFileToS3, croppedFile }: any) => {
                uploadUserAvatarToS3 = () => uploadFileToS3(croppedFile);
              }}
              positiveButtonProps={{
                children: translate('SAVE'),
                onClickButton: () => {
                  uploadUserAvatarToS3();
                },
              }}
              negativeButtonProps={{
                children: translate('CANCEL'),
              }}
              onUploadedFile={({ s3FilePath, croppedFile }: any) =>
                onUploadedTeacherAvatar(s3FilePath, croppedFile)
              }
              s3UploaderProps={{
                apiURL: FILES_API_URL,
                awsRegion: AWS_REGION,
                bucket: S3_BUCKET_FILES,
                aws_key: AWS_KEY,
              }}
              s3path={`${
                localStorage?.ORGANIZATION_ID
              }/avatars/teachers/${Date.now()}_${teacherData?.id}_`}
            />
            <Col>
              <TeacherName>
                {teacherData?.name} {teacherData?.lastname}
              </TeacherName>
              <TeacherRole>{teacherData?.role_alias}</TeacherRole>
            </Col>
          </AvatarSectionContainer>
          <Row id="teacherProfileTabs">
            <Tabs items={tabs} active={CurrentTab} onClickItem={onClickTab} />
          </Row>
          <CurrentTab.View
            centerId={centerId}
            centerName={centerName}
            teacherData={teacherData}
            onUpdateInformation={handleOnUpdateInformation}
          />
        </>
      );
    }
    return <></>;
  };

  return (
    <Container>
      {renderDeleteTeacherModal()}
      <Breadcrumbs links={links} />
      <ContentContainer>
        <Header>
          <Title>
            {translate('settings:CENTER_SECTION.TEACHER_INFORMATION')}
          </Title>
          <RendererIf condition={can(ActionPermission.DELETE_TEACHERS)}>
            <Dropdown
              noPaddingContent
              contentWidth={100}
              showIndicator={false}
              content={({ close }: any) => (
                <DropdownItem
                  onClick={() => {
                    setShowDeleteTeacherModal(true);
                    close();
                  }}
                >
                  {translate('settings:DELETE')}
                </DropdownItem>
              )}
              title={() => <Icon name="ThreeDots" size="20" />}
            />
          </RendererIf>
        </Header>
        {renderTeacherInfo()}
      </ContentContainer>
    </Container>
  );
}

export { TeacherProfile };
